export default __webpack_public_path__ + "static/media/T09F.eeca8a7b.png";